"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-unused-vars */

exports.default = {
    rules: {
        307787: function _(region) {
            return false;
        }, //drop BIG Cirpus
        1741311: function _(region) {
            return region.hasParent(1741311) && region.level == 4;
        }, //RS w/o RS-KM

        1152720: function _(region) {
            return false;
        }, //drop Ab
        1152717: function _(region) {
            return false;
        }, //drop Oset

        192691: function _(region) {
            return region.hasParent(192691) || region.osmId == 195838;
        }, //move EH to MA
        195838: function _(region) {
            return false;
        }, //drop EH

        270056: function _(region) {
            return region.hasParent(270056) || region.osmId == 449220;
        }, //move TW to CN
        449220: function _(region) {
            return false;
        } //drop TW
    }
};